<template>
    <div class="submit-dialog-container">
        <div class="submit-dialog">
        <div class="submit-dialog-header">
            <h2>提交需求</h2>
            <p>提交后官方顾问会尽快与您联系</p>
            <img src="../assets/close.png" @click="onClose">
        </div>
        <div class="submit-dialog-content" v-if="!isSuccess">
            <div class="form-item">
            <div class="form-item-label">需求服务</div>
            <div class="form-item-content form-content-text">{{name}}</div>
            </div>
            <div class="form-item">
            <div class="form-item-label">手机号</div>
            <div class="form-item-content">
                <input v-model="formData.contactNumber"
                placeholder="仅用于专家与您联系，请放心填写"
                data-track-value="landSubmitPhone" data-track-name="需求填写手机号"/>
            </div>
            </div>
            <div class="form-item">
            <div class="form-item-label">验证码</div>
            <div class="form-item-content">
                <input v-model="formData.verifyCode"
                class="verify-input"
                placeholder="请输入验证码"
                data-track-value="landSubmitVerifyCode" data-track-name="需求填写验证码"/>
                <a class="verify-btn" @click="getVerifyCode"
                    data-track-value="aqclandGetVerifyCode" data-track-name="获取验证码">{{verifyText}}</a>
            </div>
            </div>
            <div class="check-content">
            <input type="checkbox" name="checkRule" v-model="checkRule" />
            <span class="check-text">我已阅读并同意<a href="https://cloud.baidu.com/doc/Market/s/ajy71lzg2" target="_blank">《云市场服务协议》</a></span>
            </div>
            <a @click="onSubmit"
                :class="['submit-btn', checkRule && !loading && this.hasLogin ? '' : 'disable-btn']"
                data-track-value="landSubmitBtn" data-track-name="需求填写确认提交">
                <div class="error-tip login-tip" v-if="!hasLogin">提交需求前请先<a :href="loginLink">登录</a></div>
                <p class="error-tip" v-if="errorMessage">{{errorMessage}}</p>
                确认提交
            </a>
        </div>
        <div class="submit-dialog-content submit-success" v-else>
            <img src="../assets/submit_success.png">
            <p>需求提交成功，客户经理会尽快与您联系</p>
            <p>(窗口将会在{{count}}s后自动关闭)</p>
        </div>
        </div>
    </div>
</template>

<script>
import client from '../common/client.js'
import {isLogin, isOnline} from '../util/helper';

export default {
    props: ['name', 'type'],
    data () {
        return {
            formData: {
                contactNumber: '',
                verifyCode: ''
            },
            verifyText: '获取验证码',
            isSuccess: false,
            checkRule: true,
            timeLoading: false,
            errorMessage: '',
            loading: false,
            count: 5,
            hasLogin: true,
            loginLink: 'https://login.bce.baidu.com/'
        }
    },
    mounted() {
        isLogin().then(res => {
            this.hasLogin = res && res.result && res.result.hasLogin;
        });
        this.getLoginLink();
    },
    methods: {
        getVerifyCode() {
            let contactNumber = this.formData.contactNumber;
            if (!contactNumber || !/^1[0-9]{10}$/.test(contactNumber)) {
                this.errorMessage = '手机号格式不正确';
                return;
            }
            if (this.timeLoading) {
                return;
            }
            this.errorMessage = '';
            client.getVerifyCode({contactNumber}).then(res => {
                if (res.data.result === 'SUCCESS') {
                this.timeLoading = true;
                for (let i = 59; i >= 0; i--) {
                    setTimeout(() => {
                    if (i === 0) {
                        this.verifyText = '获取验证码';
                        this.timeLoading = false;
                        return;
                    }
                    this.verifyText = i + 's';
                    }, 1000 * (60 - i));
                }
                }
            });
        },
        onSubmit() {
            if (!this.checkRule || !this.hasLogin) {
                return;
            }
            this.errorMessage = '';
            let contactNumber = this.formData.contactNumber;
            if (!contactNumber || !/^1[0-9]{10}$/.test(contactNumber)) {
                this.errorMessage = '手机号格式不正确';
                return;
            }
            let verifyCode = this.formData.verifyCode;
            if (!verifyCode || !/^[0-9]{6}$/.test(verifyCode)) {
                this.errorMessage = '验证码格式不正确';
                return;
            }
            let type = this.type;
            let param = {
                contactNumber,
                verificationCode: verifyCode,
                messageType: type,
                trademarkType: type === 'TMS' ? 'AUXILIARY_REGISTRATION' : 'UNKNOWN',
                requestSource: 'aiqichaland',
                content: ''
            };
            isLogin().then(res => {
                this.hasLogin = res && res.result && res.result.hasLogin;
                if (this.hasLogin) {
                    this.loading = true;
                    client.getConsultSubmit(param).then(res => {
                        this.loading = true;
                        if (res.data.result === 'SUCCESS') {
                            this.isSuccess = true;
                            this.startCount();
                        }
                    }).catch(() => {
                        this.loading = true;
                        this.errorMessage = '验证码错误，请输入正确的验证码';
                    });
                }
            });
        },
        onClose() {
            this.$emit('close');
        },
        startCount() {
            for (let i = 5; i >= 0; i--) {
                setTimeout(() => {
                    if (i === 0) {
                        this.onClose();
                    }
                    this.count = i;
                }, 1000 * (5 - i));
            }
        },
        getLoginLink() {
            let origin = isOnline ? 'https://login.bce.baidu.com' : 'https://login.bcetest.baidu.com';
            let link = `${origin}/?redirect=`;
            if (location.href.indexOf('?') > -1) {
                let index = location.href.indexOf('?') + 1;
                link += encodeURIComponent(location.href.slice(0, index) + 'from=require&' + location.href.slice(index));
            }
            else {
                link += encodeURIComponent(location.href + '?from=require');
            }
            this.loginLink = link;
        }
    }
}
</script>

<style lang="less">
.submit-dialog-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, .5);
    .submit-dialog {
        width: 545px;
        background: #FFFFFF;
    }
    .submit-dialog-header {
        height: 56px;
        background: linear-gradient(232deg, #459BFF 0%, #006CFF 100%);
        padding-left: 33px;
        h2 {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        line-height: 22px;
        color: #FFFFFF;
        display: inline-block;
        padding-top: 17px;
        }
        p {
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 17px;
        color: #FFFFFF;
        display: inline-block;
        padding-top: 22px;
        padding-left: 10px;
        }
        img {
        width: 15px;
        height: 15px;
        float: right;
        margin: 20px;
        cursor: pointer;
        }
    }
    .submit-dialog-content {
        padding-top: 16px;
        height: 332px;
        position: relative;
        color: #ff8002;
    }
    .form-item {
        display: flex;
        align-items: flex-start;
        margin: 16px auto;
        width: 400px;
        .form-item-label {
        height: 40px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 40px;
        color: #191C3D;
        margin-right: 16px;
        width: 60px;
        }
        .form-item-content {
        position: relative;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 40px;
        color: #191C3D;
        input {
            height: 40px;
            background: #FFFFFF;
            border: 1px solid #E0E0E0;
            padding: 0 10px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 20px;
            color: #191C3D;
            width: 330px;
            outline: none;
        }
        .verify-input {
            padding-right: 90px;
        }
        .verify-btn {
            position: absolute;
            right: 10px;
            top: 10px;
            color: #D82929;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 20px;
            cursor: pointer;
        }
        }
    }
    .submit-btn {
        width: 329px;
        height: 38px;
        background: #2468F2;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        line-height: 38px;
        color: #FFFFFF;
        display: block;
        text-align: center;
        margin: 20px auto 0;
        cursor: pointer;
        position: relative;
    }
    .check-content {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 16px;
        input {
        margin-right: 4px;
        }
        .check-text {
        height: 20px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 20px;
        color: #191C3D;
        opacity: 0.5;
        a {
            text-decoration: none;
        }
        }
    }
    .submit-success {
        padding-top: 100px;
        img {
        width: 50px;
        height: 50px;
        display: block;
        margin: 0 auto 25px;
        }
        p {
        height: 22px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 22px;
        color: #191C3D;
        opacity: 0.8;
        text-align: center;
        }
    }
    .disable-btn {
        color: #aaa;
        background-color: #f5f5f5;
        cursor: not-allowed;
    }
    .error-tip {
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #EA1818;
        text-align: center;
        position: absolute;
        bottom: -34px;
        left: 0;
        width: 329px;
    }
    .login-tip {
        color: #ff8002;
        a {
            text-decoration: none;
            color: #108cee;
        }
    }
}
</style>
